import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import "./CheckBox.scss";

const CheckBox = ({ onCbChange, isChecked, label, type = "checkbox", required, error, cbLeft, htmlClasses }) => {
    return (
        <>
            <Form className="uicheckbox">
                <div key={type} className={htmlClasses ? htmlClasses : "uicb-container"}>
                    <Form.Check type={type} 
                        className={`uicheckbox-form ${error ? 'cb-error' : ''}`}>
                        {!cbLeft && <Form.Check.Label>
                            {label}
                        </Form.Check.Label>}
                        <Form.Check.Input type={type} isValid onChange={onCbChange} checked={isChecked} />
                        {cbLeft && <Form.Check.Label>
                            {label}
                            {required && (<span className="uicb-required-wrapper"><FontAwesomeIcon icon={faStar} /></span>)}
                        </Form.Check.Label>}
                        {/* <div className="uicb-required-wrapper">
                            {required && <FontAwesomeIcon icon={faStar} />}
                        </div> */}
                    </Form.Check>
                </div>
            </Form>
        </>
    )
}

export default CheckBox;